$.i18n.init(
  {
    lng: 'en-US',
    debug: true,
    useLocalStorage: false,
    localStorageExpirationTime: 86400000,
    resStore: {
      'en-US': {
        // 네비게이션
        NAV: {
          COMMING_SOON: 'Coming soon!',
          SERVICE: 'Service',
          ABOUT: 'About',
          ADVANTAGE: 'Advantage',
          HOW_IT_WORKS: 'How it works',
          FLOPPIE_IS: 'Floppie is',
          GETTING_STARTED: 'Getting Started',
          CREATING_ACCOUNT: 'Creating Account',
          SETTING_STORAGES: 'Setting Storages',
          MANAGING_DATA: 'Managing Data',
          FAQ: 'FAQ',
          SIGN_IN: 'Sign in',
          SETTINGS: 'Settings',
          PERSONAL_INFO: 'Personal Info',
          STORAGE_MANAGEMENT: 'Storage Management',
          SIGN_OUT: 'Sign Out',
        },
        // About
        ABOUT: {
          SLOGAN_1: 'Expand Your Storage',
          SLOGAN_2: 'Protect Your Data',
          SUB_SLOGAN_1: 'Fragmented Cloud Storages Into a Single Meta-Cloud ',
          SUB_SLOGAN_2: 'Digital Data Vault with Decentralization',
          LEARN_MORE: 'Learn more',
          // Advantage
          ADVANTAGE_TITLE_1: 'Expand Your Storage',
          ADVANTAGE_DETAIL_1: 'Floppie Client Merges Your Fragmented Cloud Storgages Into A Single Meta-Cloud Storage.',
          ADVANTAGE_TITLE_2: 'Protect Your Data',
          ADVANTAGE_DETAIL_2: 'Data is Encrypted and Protected by Cryptographic Security and Decentralization.',
          ADVANTAGE_TITLE_3: 'Own Sovereignty',
          ADVANTAGE_DETAIL_3: 'You Are The Only One Who Hold And See The Data. Even Floppie Dont Know What Your Data Is.',
          // How it works?
          HOW_IT_WORKS: 'How it works?',
          // Step 1
          STEP_1: 'STEP #1',
          STEP_1_TITLE: 'Objects are encrypted.',
          STEP_1_DETAIL: 'Floppie automatically encrypts every data before being uploaded.',
          STEP_1_QUESTION_1: 'Can Floppie see the stored data?',
          STEP_1_ANSWER_1: 'No. Files are encrypted, split into pieces, and stored on geographically diverse Nodes, making data breaches a thing of the past.',
          STEP_1_QUESTION_2: 'What kind of encryption is applied?',
          STEP_1_ANSWER_2:
            'Every file is encrypted using AES-256-GCM symmetric encryption. This is standard on every file before being uploaded to our network to ensure no unauthorized user can access it.',
          // Step 2
          STEP_2: 'STEP #2',
          STEP_2_TITLE: 'Encrypted data are fragmented into small data pieces.',
          STEP_2_DETAIL: 'After being encrypted, each data file is fragmented into pieces of a given size.',
          STEP_2_QUESTION_1: 'Why split up the files',
          STEP_2_ANSWER_1: 'Splitting files provides a level higher security to the storage by making each fragment are indistinguishabe from each other.',
          // Step 3
          STEP_3: 'STEP #3',
          STEP_3_TITLE: 'Data fragments are distributed across the clouds',
          STEP_3_DETAIL: 'Individual data fragments are distributed and stored over multiple could storages of yours.',
          STEP_3_QUESTION_1: 'Where are the data storage nodes?',
          STEP_3_ANSWER_1:
            'Floppie does not maintain any data node of own. Floppie weaves the cloud storage that users are already using and uses it like a distributed data node.',
          // Step 4
          STEP_FLOPPIE_IS: 'STEP #4',
          STEP_4_TITLE: 'Data is retrieved when you need.',
          STEP_4_DETAIL: 'When you retrieve data, data fragment over the multiple cloud storage of yours will be downloaded and decrypted into a single data file.',
          STEP_4_QUESTION_1: 'What happens if a cloud storage goes down?',
          STEP_4_ANSWER_1:
            'Even if a cloud storage goes down, it does not affect because the whole data can be restored from the data stored in the other remaining cloud storages.',
          // Floppie is
          FLOPPIE_IS: 'Floppie is',
          // Mission
          MISSION: 'Mission',
          MISSION_TXT: 'The ambition of Floppie is to build a network of trust on the internet using blockchain.',
          // Roadmap
          ROADMAP: 'Roadmap',
          YEAR1: '2019',
          YEAR1_TXT: 'Floppie Service Conceived',
          YEAR2: '2020.08',
          YEAR2_TXT: 'Floppie Team Launched',
          YEAR3: '2021.05',
          YEAR3_TXT: 'Fast Flow INC. Established',
          YEAR4: '2022.05',
          YEAR4_TXT: 'Floppie Beta Service Launch',
          YEAR5: '2023',
          YEAR5_TXT: 'Global Network Storage Establish',
          // Our Team
          OUR_TEAM: 'Our team',
          // member1
          TEAM1_RANK: 'CEO/CTO',
          TEAM1_NAME: 'Heungjin Kim',
          TEAM1_CAREER1: 'Ph.D(ABD) Computer Science Engineering, Korea Univ.',
          TEAM1_CAREER2: 'MS&BA, Physics, Seoul National Univ.',
          TEAM1_CAREER3: 'Blockchain Developer of YosemiteX',
          TEAM1_CAREER4: 'SW Engineer of Woowabros',
          // member2
          TEAM2_RANK: 'CSO/Co-founder',
          TEAM2_NAME: 'Juhyun Kim',
          TEAM2_CAREER1: 'BA, Electronic Engineering, Hongik Univ.',
          TEAM2_CAREER2: 'Strategic Planning of LG Electronics',
          TEAM2_CAREER3: 'Mobile Phone Developer of Samsung Electronics',
          TEAM2_CAREER4: 'PM, New Car Project in GM Korea',
          // member3
          TEAM3_RANK: 'COO/Co-founder',
          TEAM3_NAME: 'Deukli Kong',
          TEAM3_CAREER1: 'MS, Ferrous Technology, POSTECH',
          TEAM3_CAREER2: 'BA, Chemistry, POSTECH',
          TEAM3_CAREER3: 'Blockchain Planning of BaaS Store',
          TEAM3_CAREER4: 'Blockchain Service Planning of WeLink Global (Scoutchain)',
          // Partners
          PARTNERS: 'Partners',
        },
        // Service
        SERVICE: {
          SERVICE: 'Service',
          DASHBOARD: 'Dashboard',
          STORAGE: 'Storage',
          REMAINING: 'Remaining',
          CONNECTED_STORAGES: 'Connected Storages',
          MANAGE_VERSIONS: 'Manage versions',
          MAKE_A_COPY: 'Make a copy',
          REPORT_ABUSE: 'Report abuse',
          DOWNLOAD: 'Download',
          REMOVE: 'Remove',
        },
        // Getting Started
        GETTING_STARTED: {
          GETTING_STARTED: 'Getting Started',
          CREATING_ACCOUNT: 'Creating Account',
          CREATING_ACCOUNT_STEP_1: 'STEP 1',
          CREATING_ACCOUNT_STEP_1_TITLE: 'Creating account instruction sample1',
          CREATING_ACCOUNT_STEP_1_DETAIL_1: 'Expand Your Storage Expand Your Storage Expand Your Storage',
          CREATING_ACCOUNT_STEP_1_DETAIL_2: 'Expand Your Storage Expand Your Sto YourYour Sto',
          CREATING_ACCOUNT_STEP_1_DETAIL_3: 'Your Sto Your StoYour Sto Your Sto',
          CREATING_ACCOUNT_STEP_2: 'STEP 2',
          CREATING_ACCOUNT_STEP_2_TITLE: 'Creating account instruction sample2',
          CREATING_ACCOUNT_STEP_2_DETAIL_1: 'Expand Your Storage Expand Your Storage Expand Your Storage',
          CREATING_ACCOUNT_STEP_2_DETAIL_2: 'Expand Your Storage Expand Your Sto YourYour Sto',
          CREATING_ACCOUNT_STEP_2_DETAIL_3: 'Your Sto Your StoYour Sto Your Sto',
          SETTING_STORAGES: 'Setting Storages',
          SETTING_STORAGES_STEP_1: 'STEP 1',
          SETTING_STORAGES_STEP_1_TITLE: 'Setting storages instruction sample1',
          SETTING_STORAGES_STEP_1_DETAIL_1: 'Expand Your Storage Expand Your Storage Expand Your Storage',
          SETTING_STORAGES_STEP_1_DETAIL_2: 'Expand Your Storage Expand Your Sto YourYour Sto',
          SETTING_STORAGES_STEP_1_DETAIL_3: 'Your Sto Your StoYour Sto Your Sto',
          SETTING_STORAGES_STEP_2: 'STEP 2',
          SETTING_STORAGES_STEP_2_TITLE: 'Setting storages instruction sample2',
          SETTING_STORAGES_STEP_2_DETAIL_1: 'Expand Your Storage Expand Your Storage Expand Your Storage',
          SETTING_STORAGES_STEP_2_DETAIL_2: 'Expand Your Storage Expand Your Sto YourYour Sto',
          SETTING_STORAGES_STEP_2_DETAIL_3: 'Your Sto Your StoYour Sto Your Sto',
          MANAGING_DATA: 'Managing Data',
          MANAGING_DATA_STEP_1: 'STEP 1',
          MANAGING_DATA_STEP_1_TITLE: 'Managing data instruction sample1',
          MANAGING_DATA_STEP_1_DETAIL_1: 'Expand Your Storage Expand Your Storage Expand Your Storage',
          MANAGING_DATA_STEP_1_DETAIL_2: 'Expand Your Storage Expand Your Sto YourYour Sto',
          MANAGING_DATA_STEP_1_DETAIL_3: 'Your Sto Your StoYour Sto Your Sto',
          MANAGING_DATA_STEP_2: 'STEP 2',
          MANAGING_DATA_STEP_2_TITLE: 'Managing data instruction sample2',
          MANAGING_DATA_STEP_2_DETAIL_1: 'Expand Your Storage Expand Your Storage Expand Your Storage',
          MANAGING_DATA_STEP_2_DETAIL_2: 'Expand Your Storage Expand Your Sto YourYour Sto',
          MANAGING_DATA_STEP_2_DETAIL_3: 'Your Sto Your StoYour Sto Your Sto',
        },
        // FAQ
        FAQ: {
          FAQ: 'FAQ',
          QUESTION_1: 'When I forget my password, how can I solve?',
          ANSWER_1:
            "Floppie service uses existing account of user such as Google or Microsoft or Dropbox in the form of OAuth.  There is no Floppie's own service account. If you are unable to sign in due to the incorrect password, you must chech your password at the service you are using that account.",
          QUESTION_2: 'When I forget my PIN code, how can I solve?',
          ANSWER_2:
            'If you forget your PIN code, you can register a new PIN code on the Modify Personal Information page. To register a new PIN code, you must know the password of your account .',
          QUESTION_3: 'Does the PIN code have to be the same for each device?',
          ANSWER_3: "In Floppie service, PIN codes are stored separately for each device. Therefore, depending on the user's mind, it can be same or it can be different.",
          QUESTION_4: 'Is it right that even the Floppie operator cannot see my data?',
          ANSWER_4:
            'Every data is encrypted at the client level before being uploaded. The encryption key can only be restored by the PIN code that only user knows. Floppie cannot decrypt the data because Floppie does not have permission for the PIN code.',
          QUESTION_5: "Is it right that even Google, Microsoft, and Dropbox can't see my data?",
          ANSWER_5:
            'Every data is split into several pieces of a given size. Each fragment are encrypted and stored across the multiple cloud storages. Every single fragment is nothing more than the undecipherable random byte codes of a given size. ',
          QUESTION_6: "Can't I use other clouds besides Google Drive, One Drive, and Dropbox?",
          ANSWER_6: 'Currently, only the above three services can be inter-connected. Floppie plan to connect more cloud storage services in the future.',
        },
        // USER
        USER: {
          // Personal Info
          PERSONAL_INFO: 'Personal Info',
          EDIT_INFO: 'Edit Info',
          SAVE_CHANGES: 'Save Changes',
          SIGN_UP: 'Sign Up',
          // PIN Reset
          PIN_RESET: 'PIN Reset',
          RESET_THE_PIN: 'Reset the PIN',
          // Storage management
          STORAGE_MANAGEMENT: 'Storage Management',
          CREATING_ACCOUNT: 'Creating Account',
          CONNECT_MORE: 'Connect More',
        },
        // Error messages
        ERROR_MSG: {
          ID_ERROR: '5~20 Characters Consisting Of Alphabet Or Numbers Impossible',
          PIN_CODE_ERROR: '4~8 Characters Consisting Of Numbers',
          RE_ENTER_PIN_ERROR: "PIN Codes don't match",
        },
        // 로그아웃 모달
        SIGN_OUT: {
          TITLE1: 'Are you',
          TITLE2: 'sure to sign out?',
          YES: 'Yes',
          NO: 'No',
        },
        // Terms of servie
        TERMS: {
          TITLE: 'Terms of service',
          TERMS_TITLE1: '1. Purpose',
          TERMS_CONTENT1_1:
            'The purpose of these Terms of Services lies in specifying rights, obligations and reliabilities, and etc. of Fast Flow INC. (“the Company”) and members (the “Member”), in relation of the use of Floppie service(the “Service”) provided by the Company.',
          TERMS_TITLE2: '2. Definitions',
          TERMS_CONTENT2_1: 'Terms are defined as follows:',
          TERMS_CONTENT2_2:
            '1. “Service” refers to cloud service by which the Member saves data to the online data storage and accessed freely from various Devices using client provided by the Company.',
          TERMS_CONTENT2_3:
            '2. “Member” refers to an individual who enters into service agreement with the Company in accordance with these Terms of Services and hence is entitled to use the Service.',
          TERMS_CONTENT2_4: '3. “the Company” refers to the authorized Service operator, the Fast Flow Inc. who are entrusted by the Floppie Foundation Ltd.',
          TERMS_CONTENT2_5: '4. “Webpage” refers to an internet page providing the Service.',
          TERMS_TITLE3: '3. Posting and Amendment of Terms',
          TERMS_CONTENT3_1: '1. The Company shall post these Terms of Services to a screen within the Service or connected by links, so as the Member can easily recognize.',
          TERMS_CONTENT3_2:
            '2. The Company revise the Terms of Services, as long as they do not violate relevant acts, including Act on the Regulations of Terms and Conditions and Act on Promotion of Information and Communications Network Utilization and Information Protection, Etc.',
          TERMS_CONTENT3_3:
            '3. In case the Company revises the Terms of Services, the date and cause of revision shall be clearly specified and posted from 7 days before such revision date until the previous date of application, in accordance with paragraph 1.',
          TERMS_CONTENT3_4:
            '4. The Company, unless particularly specified in the Terms and relevant acts, shall not be eligible for any damage incurred to the Member due to change, modification, or termination of the Service.',
          TERMS_TITLE4: '6. Service Offering',
          TERMS_CONTENT4_1:
            '1. The Company shall provide such services, by which the Member can save the Content within the Device through the Client or the Web Page, or save the Content of the Storage Server on the Device.',
          TERMS_CONTENT4_2: '2. The Service shall be enabled under wired/wireless network connection, such as 3G, Wi-Fi, LTE, or LAN connection.',
          TERMS_CONTENT4_3: '3. The Company does not own any rights to Your Stuff except for the limited rights that enable us to offer the Services.',
          TERMS_TITLE5: '7. Change or Termination of Service',
          TERMS_CONTENT5_1:
            '1. Depending on the operational, administrative, or technical needs, the Company may change all or parts of the Service, and if there is a change in the content or method of use, such change shall be notified 7 days before, along with reasons and content of changes and application date',
          TERMS_CONTENT5_2: '2. For the closure of the Service, the Company shall be notify it 30 days before, on the startup page of the Service.',
          TERMS_TITLE6: '11. Company’s Obligations',
          TERMS_CONTENT6_1:
            '1. The Company, to provide continued and stable service, shall restore or repair failed or destroyed facilities of the Company or the Client, immediately after occurrence.',
          TERMS_CONTENT6_2: '2. The Company must handle suggestions or complaints made by the Member in relation to the Service, if they are acknowledged to be just.',
          TERMS_CONTENT6_3:
            '3. The Company shall abide by relevant acts, including Act on Promotion of Information and Communications Network Utilization and Information Protection, Act on the Development of Cloud Computing and Protection of Its Users, Protection of Communications Secrets Act, Telecommunications Business Act, and Copyright Act.',
          TERMS_TITLE7: '12. Member’s Obligations',
          TERMS_CONTENT7_1: '1. The Member shall not be allowed to do each of the following subparagraphs, when using the Service:',
          TERMS_CONTENT7_2: '- 1. Post false information for application or change of Member Information, or abuse ID and Password of other members without consent;',
          TERMS_CONTENT7_3: '- 2. Abnormal use of the service, such as immoderate traffic, multiple access, or frequent change of access IP within a short period of time;',
          TERMS_CONTENT7_4: '- 3. The act of impersonating the Company;',
          TERMS_CONTENT7_5: '- 4. Any other acts that obstruct stable operations of the Service;',
          TERMS_CONTENT7_6: '',
          TERMS_CONTENT7_7:
            '2. The Member is obligated to respect stipulations of these Terms, operational policy and relevant acts, and should not take actions that may damage honor of the Company or interrupt work performance remarkably.',
          TERMS_TITLE8: '21. Governing Law and Jurisdictions',
          TERMS_CONTENT8_1: '1. Matters not specified in this Terms and Conditions shall be governed by the laws and regulations of the Republic of Korea.',
          TERMS_CONTENT8_2:
            '2. If a lawsuit is filed against a dispute arising from the use of the Service, the court having jurisdiction over the address under the Civil Procedure Act shall be the jurisdiction of the agreement.',
        },
        // Privacy policy
        POLICY: {
          TITLE: 'Privacy policy',
          POLICY_TITLE1: '1. Collecting Personal Information',
          POLICY_CONTENT1_1: 'A. Collecting Personal Information',
          POLICY_CONTENT1_2: 'Personal information shall be collected as follows, in the process of member subscription:',
          POLICY_CONTENT1_3: '- Common Information: (Required) ID (email address)',
          POLICY_CONTENT1_4: 'Information as below may be created and collected, in the process of service use:',
          POLICY_CONTENT1_5: '- IP Address, Cookies, Visit Date/Time, Service Use History',
          POLICY_TITLE2: '2. Purpose of Collecting and Using Personal Information',
          POLICY_CONTENT2_1: 'The Company shall use collected personal information for the following purposes:',
          POLICY_CONTENT2_2: '- To provide services as promised, verify user identity, confirm intent of withdrawal, process inquiries or complaints.',
          POLICY_TITLE3: '3. Retention and Usage Period of Personal Information',
          POLICY_CONTENT3_1: 'The Company, on principle, shall retain user’s personal information until user’s withdrawal.',
        },
      },
      'ko-KR': {
        // 네비게이션
        NAV: {
          COMMING_SOON: '준비중입니다!',
          SERVICE: '탐색기',
          ABOUT: '서비스소개',
          ADVANTAGE: '장점',
          HOW_IT_WORKS: '원리',
          FLOPPIE_IS: '플로피 소개',
          GETTING_STARTED: '시작하기',
          CREATING_ACCOUNT: '계정 만들기',
          SETTING_STORAGES: '스토리지 연동하기',
          MANAGING_DATA: '데이터 관리하기',
          FAQ: 'FAQ',
          SIGN_IN: '로그인',
          SETTINGS: '세팅',
          PERSONAL_INFO: 'Personal Info',
          STORAGE_MANAGEMENT: 'Storage Management',
          SIGN_OUT: '로그아웃',
        },
        // About
        ABOUT: {
          SLOGAN_1: '넓어진 스토리지',
          SLOGAN_2: '안전한 데이터',
          SUB_SLOGAN_1: '파편화 된 스토리지들을 마치 한개의 스토리지처럼 편리하게',
          SUB_SLOGAN_2: '최신 암호화 기술과 탈중앙화로 데이터를 안전하게',
          LEARN_MORE: 'Learn more',
          // Advantage
          ADVANTAGE_TITLE_1: '넓어진 스토리지',
          ADVANTAGE_DETAIL_1: '플로피 클라이언트에서 파편화 된 클라우드 스토리지들이 하나처럼 합쳐집니다.',
          ADVANTAGE_TITLE_2: '안전한 데이터',
          ADVANTAGE_DETAIL_2: '모든 데이터는 최신 암호화 기술과 탈중앙화에 의해서 안전하게 지켜집니다.',
          ADVANTAGE_TITLE_3: '정보 주권 회복',
          ADVANTAGE_DETAIL_3: '플로피에서 데이터의 소유자는 오로지 당신 뿐입니다. 아무도 당신의 데이터를 알 수 없습니다.',
          // How it works?
          HOW_IT_WORKS: '어떻게 작동합니까?',
          // Step 1
          STEP_1: 'STEP #1',
          STEP_1_TITLE: '모든 데이터는 암호화됩니다.',
          STEP_1_DETAIL: '플로피에서 모든 데이터는 업로드되기 전에 클라이언트에서 암호화됩니다.',
          STEP_1_QUESTION_1: '플로피 운영자는 저장된 데이터를 볼 수 있습니까?',
          STEP_1_ANSWER_1:
            '아니요. 당신의 데이터는 암호화되어 여러 조각으로 나눠진 채로 네트워크 상에 저장됩니다. 오로지 당신의 ID와 PIN에 의해서만 데이터는 복원되기 때문에 당신을 제외한 그 누구도 알 수 없습니다.',
          STEP_1_QUESTION_2: '어떻게 암호화 됩니까?',
          STEP_1_ANSWER_2: '모든 파일은 네트워크에 업로드되기 전에 AES-256-GCM 대칭 암호화를 사용하여 암호화됩니다.',
          // Step 2
          STEP_2: 'STEP #2',
          STEP_2_TITLE: '암호화된 데이터는 작은 데이터 조각으로 파편화됩니다.',
          STEP_2_DETAIL: '암호화 된 데이터는 서로 구별할 수 없도록 동일한 크기의 조각으로 파편화됩니다.',
          STEP_2_QUESTION_1: '파일을 분할하는 이유',
          STEP_2_ANSWER_1: '각각의 조각들이 서로 구별할 수 없도록 동일한 크기로 분할함으로써 손쉽게 보안 수준을 한단계 높일 수 있습니다',
          // Step 3
          STEP_3: 'STEP #3',
          STEP_3_TITLE: '분할된 데이터 조각들은 소유자의 클라우드 스토리지들에 나눠서 저장됩니다.',
          STEP_3_DETAIL: '분할된 파일 조각들은 네트워크 상에 분산저장된 상태로 관리됩니다.',
          STEP_3_QUESTION_1: '데이터 스토리지 노드는 어디에 있습니까?',
          STEP_3_ANSWER_1:
            '플로피는 사용자에게 데이터 노드를 따로 제공하지 않습니다. 플로피는 사용자가 이미 사용중인 클라우드 스토리지를 동기화해서 분산 데이터 노드처럼 사용합니다.',
          // Step 4
          STEP_4: 'STEP #4',
          STEP_4_TITLE: '사용자의 요청에 의해 데이터를 복원합니다.',
          STEP_4_DETAIL: '사용자가 데이터 복원을 요청하면 클라우드 속에 나눠서 저장된 데이터 조각들을 즉시 다운로드 하여 사용자의 디바이스 안에서 복원되어 사용가능해집니다.',
          STEP_4_QUESTION_1: '클라우드 스토리지가 다운되면 어떻게 됩니까?',
          STEP_4_ANSWER_1: '하나의 클라우드가 오프라인 상태가 되어도 나머지 클라우드 안에 저장되어 있는 데이터를 이용해서 복원이 가능하기 때문에 영향을 주지 않습니다. ',
          // Floppie is
          FLOPPIE_IS: '플로피 소개',
          // Mission
          MISSION: 'Mission',
          MISSION_TXT: '플로피는 블록체인이 가져올 긍정적 미래를 믿습니다. 플로피의 목표는 블록체인을 이용해서 인터넷 위에 신뢰를 구축하는 것입니다.',
          // Roadmap
          ROADMAP: 'Roadmap',
          YEAR1: '19년',
          YEAR1_TXT: '플로피 서비스 구상',
          YEAR2: '20년 8월',
          YEAR2_TXT: '플로피 팀 발족',
          YEAR3: ' 21년 5월',
          YEAR3_TXT: '플로피 주식회사 설립',
          YEAR4: '22년 5월',
          YEAR4_TXT: '베타 서비스 런칭 예정',
          YEAR5: '23년',
          YEAR5_TXT: '글로벌 스토리지 네트워크 구축',
          // Our Team
          OUR_TEAM: 'Our team',
          // member1
          TEAM1_RANK: 'CEO/CTO',
          TEAM1_NAME: '김흥진',
          TEAM1_CAREER1: '서울대학교 물리학과 학사, 석사',
          TEAM1_CAREER2: '고려대학교 컴퓨터공학 박사 수료',
          TEAM1_CAREER3: 'YosemiteX / 블록체인 개발',
          TEAM1_CAREER4: '우아한형제들 / O2O 중개시스템 개발',
          // member2
          TEAM2_RANK: 'CSO/Co-founder',
          TEAM2_NAME: '김주현',
          TEAM2_CAREER1: '홍익대학교 전기전자공학 학사',
          TEAM2_CAREER2: 'LG전자 SW전략실',
          TEAM2_CAREER3: '삼성전자 무선사업부',
          TEAM2_CAREER4: 'GM코리아 신차 프로젝트 팀',
          // member3
          TEAM3_RANK: 'COO/Co-founder',
          TEAM3_NAME: '공득리',
          TEAM3_CAREER1: '포스텍 화학 학사',
          TEAM3_CAREER2: '포스텍 철강학 석사',
          TEAM3_CAREER3: '스카우트체인 / 블록체인 서비스 기획',
          TEAM3_CAREER4: '바스스토어 / 블록체인 서비스 기획',
          // Partners
          PARTNERS: 'Partners',
        },
        // Service
        SERVICE: {
          SERVICE: '탐색기',
          DASHBOARD: '대시보드',
          STORAGE: '스토리지',
          REMAINING: '남은',
          CONNECTED_STORAGES: '연결된 스토리지',
          MANAGE_VERSIONS: '버전관리',
          MAKE_A_COPY: '복사',
          REPORT_ABUSE: '남용 신고',
          DOWNLOAD: '다운로드',
          REMOVE: '삭제',
        },
        // Getting Started
        GETTING_STARTED: {
          GETTING_STARTED: '시작하기',
          CREATING_ACCOUNT: '계정 생성',
          CREATING_ACCOUNT_STEP_1: 'STEP 1',
          CREATING_ACCOUNT_STEP_1_TITLE: '계정 생성 샘플1',
          CREATING_ACCOUNT_STEP_1_DETAIL_1: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지 확장 스토리지 ',
          CREATING_ACCOUNT_STEP_1_DETAIL_2: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지',
          CREATING_ACCOUNT_STEP_1_DETAIL_3: '스토리지 확장 스토리지 확장 스토리지 확장',
          CREATING_ACCOUNT_STEP_2: 'STEP 2',
          CREATING_ACCOUNT_STEP_2_TITLE: '계정 생성 샘플2',
          CREATING_ACCOUNT_STEP_2_DETAIL_1: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지 확장 스토리지 ',
          CREATING_ACCOUNT_STEP_2_DETAIL_2: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지',
          CREATING_ACCOUNT_STEP_2_DETAIL_3: '스토리지 확장 스토리지 확장 스토리지 확장',
          SETTING_STORAGES: '스토리지 설정',
          SETTING_STORAGES_STEP_1: 'STEP 1',
          SETTING_STORAGES_STEP_1_TITLE: '스토리지 설정 샘플1',
          SETTING_STORAGES_STEP_1_DETAIL_1: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지 확장 스토리지 ',
          SETTING_STORAGES_STEP_1_DETAIL_2: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지',
          SETTING_STORAGES_STEP_1_DETAIL_3: '스토리지 확장 스토리지 확장 스토리지 확장',
          SETTING_STORAGES_STEP_2: 'STEP 2',
          SETTING_STORAGES_STEP_2_TITLE: '스토리지 설정 샘플2',
          SETTING_STORAGES_STEP_2_DETAIL_1: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지 확장 스토리지 ',
          SETTING_STORAGES_STEP_2_DETAIL_2: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지',
          SETTING_STORAGES_STEP_2_DETAIL_3: '스토리지 확장 스토리지 확장 스토리지 확장',
          MANAGING_DATA: '데이터 관리',
          MANAGING_DATA_STEP_1: 'STEP 1',
          MANAGING_DATA_STEP_1_TITLE: '데이터 관리 샘플1',
          MANAGING_DATA_STEP_1_DETAIL_1: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지 확장 스토리지 ',
          MANAGING_DATA_STEP_1_DETAIL_2: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지',
          MANAGING_DATA_STEP_1_DETAIL_3: '스토리지 확장 스토리지 확장 스토리지 확장',
          MANAGING_DATA_STEP_2: 'STEP 2',
          MANAGING_DATA_STEP_2_TITLE: '데이터 관리 샘플2',
          MANAGING_DATA_STEP_2_DETAIL_1: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지 확장 스토리지 ',
          MANAGING_DATA_STEP_2_DETAIL_2: '스토리지 확장 스토리지 확장 스토리지 확장 스토리지',
          MANAGING_DATA_STEP_2_DETAIL_3: '스토리지 확장 스토리지 확장 스토리지 확장',
        },
        // FAQ
        FAQ: {
          FAQ: 'FAQ',
          QUESTION_1: '비밀번호를 잊었을 때는 어떻게 하나요?',
          A1: '플로피 서비스의 계정은 사용자가 사용 중인 구글이나 마이크로소프트 등의 계정을 소셜로그인의 형식으로 사용하며 그 과정에서 따로 플로피 서비스만의 비밀번호를 사용하지 않습니다. 플로피 로그인 과정에서 잘못된 비밀번호로 인해서 로그인이 안 된다면 해당 계정을 사용 중인 서비스에서 비밀번호 찾기를 통해서 새로운 비밀번호를 발급받아야 합니다.',
          QUESTION_2: 'PIN 코드를 잊었을 때는 어떻게 하나요?',
          A2: '사용 중인 PIN 코드를 잊어버렸을 경우 개인정보 수정 페이지에서 새로운 PIN 코드를 등록할 수 있습니다. 새로운 PIN 코드를 등록하기 위해서는 현재 플로피에서 사용 중인 계정의 비밀번호가 필요합니다.',
          QUESTION_3: 'PIN 코드는 기기별로 같아야 하나요?',
          A3: '플로피 서비스에서 PIN 코드는 기기 별로 따로 저장됩니다. 따라서 사용자의 의사에 따라 동일하게 만들 수도, 다르게 만들 수도 있습니다.',
          QUESTION_4: '내 데이터를 플로피 운영자도 알 수 없는 게 맞나요?',
          A4: '사용자의 모든 데이터는 업로드되기 전에 클라이언트 레벨에서 암호화되며, 해당 암호화 키는 사용자만이 알고 있는 PIN 코드로만 복원할 수 있습니다. 플로피는 해당 PIN 코드에 대한 권한이 없기 때문에 암호화된 데이터를 뜯어 볼 수 없습니다.',
          QUESTION_5: '구글이나 마이크로소프트, 드랍박스도 내 데이터를 볼 수 없는 게 맞나요?',
          A5: '플로피에서 모든 데이터는 조각조각 나눠서 암호화된 상태로 여러 클라우드 스토리지에 분산 저장됩니다. 모든 파일은 해당 클라우드 서비스 내에서는 내용을 알 수 없는 데이터 조각에 지나지 않기 때문에 해당 데이터만 가지고 원본을 알 수 없습니다.',
          QUESTION_6: '구글 드라이브, 원 드라이브, 드랍박스 외에 다른 클라우드도 사용할 수는 없나요?',
          A6: '현재는 위 3가지 서비스만 연동 가능하며 앞으로 점점 연동 가능한 서비스를 늘려나갈 예정입니다.',
        },
        // User
        USER: {
          // Personal Info
          PERSONAL_INFO: '개인 정보',
          EDIT_INFO: '정보 수정',
          SAVE_CHANGES: '변경 사항 저장',
          SIGN_UP: '회원가입',
          // PIN Reset
          PIN_RESET: 'PIN 재설정',
          RESET_THE_PIN: 'PIN 재설정',
          // Storage management
          STORAGE_MANAGEMENT: '스토리지 관리',
          CREATING_ACCOUNT: '계정 생성',
          CONNECT_MORE: '더 연결하기',
        },
        // Error messages
        ERROR_MSG: {
          ID_ERROR: '알파벳 또는 숫자로 구성된 5~20자 불가능',
          PIN_CODE_ERROR: '숫자로 구성된 4~8자로 입력해주세요',
          RE_ENTER_PIN_ERROR: 'PIN 코드가 일치하지 않습니다',
        },
        // 로그아웃 모달
        SIGN_OUT: {
          HEAD_TXT1: '정말로',
          HEAD_TXT2: '로그아웃 하시겠습니까?',
          YES: '네',
          NO: '아니오',
        },

        // Terms of servie
        TERMS: {
          TITLE: '플로피 서비스 이용약관',
          TERMS_TITLE1: '제 1 조 목적',
          TERMS_CONTENT1_1: '이 약관은 플로피 서비스(이하 “서비스”)를 이용하는 “회원”의 서비스 이용에 필요한 사항을 정함을 목적으로 합니다.',
          TERMS_TITLE2: '제 2 조 용어의 정의',
          TERMS_CONTENT2_1: '본 약관에서 사용하는 용어의 정의는 다음과 같습니다.',
          TERMS_CONTENT2_2:
            '1. “서비스”란 “회원”이 “회사”가 제공하는 클라이언트를 이용해서 파일을 온라인 저장 공간에 저장하고, 이를 다양한 디바이스에서 자유롭게 이용하는 클라우드 서비스를 말합니다.',
          TERMS_CONTENT2_3: '2. “회원”이란 본 약관에 동의하고 “서비스”를 이용하는 사용자를 말합니다.',
          TERMS_CONTENT2_4: '3. “회사”란 플로피 재단의 기술과 권한을 이양받아 서비스를 기술적으로 유지하고 “회원”들에게 서비스를 제공하는 (주)패스트플로우를 말합니다.',
          TERMS_CONTENT2_5: '4. “사이트”란 ‘서비스’를 제공하기 위해 회사가 운영하는 웹사이트(floppie.io)를 말합니다.',
          TERMS_TITLE3: '제 3 조 약관의 효력 및 개정',
          TERMS_CONTENT3_1: '1. “회사”는 이 약관의 내용을 “회원”이 쉽게 알 수 있도록 “서비스” 내의 화면 또는 링크로 연결된 화면에 게시합니다.',
          TERMS_CONTENT3_2:
            '2. “회사”는 ‘약관의 규제에 관한 법률’, ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 등 관계법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.',
          TERMS_CONTENT3_3:
            '3. “회사”가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 제1항의 방식에 따라 그 개정약관을 적용일자 7일 전부터 적용일자 전일까지 공지합니다.',
          TERMS_CONTENT3_4:
            '4. “회사”는 이 약관 및 관계법령에 특별한 규정이 없는 한 “서비스”의 변경, 내용 수정 또는 종료로 인하여 “회원”이 입은 손해에 대해 아무런 책임을 지지 않습니다.',
          TERMS_TITLE4: '제 4 조 ‘서비스’ 내용',
          TERMS_CONTENT4_1:
            '1. “회사”는 “회원”이 “클라이언트”, “웹 페이지”를 통하여 “디바이스”내 “콘텐츠”를 “스토리지 서버”에 저장하거나 “스토리지 서버”에 저장된 “콘텐츠”를 “디바이스”에 저장할 수 있도록 서비스를 제공합니다.',
          TERMS_CONTENT4_2: '2. “서비스”는 3G망, Wi-Fi 망, LTE망, LAN 연결 등 유/무선 네트워크가 연결된 상태에서 이용할 수 있습니다.',
          TERMS_CONTENT4_3: '3. “회사”는 서비스를 제공하기 위해 필요한 제한된 권한을 제외하고 사용자의 자료에 관한 그 어떠한 추가적인 권한을 소유하지 않습니다.',
          TERMS_TITLE5: '제 5 조 ‘서비스’의 중단 및 변경',
          TERMS_CONTENT5_1:
            '1. “회사”는 운영상, 경영상, 기술상의 필요에 따라 “서비스”의 전부 또는 일부 내용을 변경할 수 있으며, “서비스”의 내용, 이용방법 등에 대하여 변경이 있는 경우에는 변경사유, 변경내용 및 제공일자 등을 변경 7일 전에 해당 사실을 공지합니다.',
          TERMS_CONTENT5_2: '2. “회사”는 운영상, 경영상, 기술상의 필요에 따라 “서비스”를 종료하는 경우에는 종료 30일 전에 “서비스” 초기화면에 해당 사실을 공지합니다.',
          TERMS_TITLE6: '제 6 조 ‘회사’의 의무',
          TERMS_CONTENT6_1:
            '1. “회사”는 계속적이고 안정적인 “서비스”의 제공을 위하여 “회사”의 설비 또는 “클라이언트”에 장애가 생기거나 파손되는 경우 부득이한 사유가 없는 한 곧바로 이를 복구 또는 수리합니다.',
          TERMS_CONTENT6_2: '2. “회사”는 “서비스”와 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.',
          TERMS_CONTENT6_3:
            '3. “회사”는 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’, ‘클라우드 컴퓨팅 발전 및 이용자 보호에 관한 법률’, ‘통신비밀보호법’, ‘전기통신사업법’, ‘저작권법’ 등 관계법령을 준수합니다.',
          TERMS_TITLE7: '제 7 조 ‘회원’의 의무',
          TERMS_CONTENT7_1: '1. “회원”은 “서비스”를 이용할 때 다음 각 호의 행위를 해서는 안 됩니다.',
          TERMS_CONTENT7_2: '- 1. 이용신청 또는 “회원정보” 변경 시 허위 사실을 기재하거나 다른 “회원”의 “아이디(ID)”와 “비밀번호”를 무단으로 사용하는 행위',
          TERMS_CONTENT7_3: '- 2. 과도한 트래픽이 발생하거나, 다중 접속, 단시간 내 접속 IP 가 수시로 변경되는 등 비정상적으로 서비스를 이용하는 행위',
          TERMS_CONTENT7_4: '- 3. “회사”를 사칭하는 행위',
          TERMS_CONTENT7_5: '- 4. 악성 프로그램 및 버그를 이용하거나 시스템 취약점을 악용하는 등 부정한 방법을 "서비스"에 사용하는 행위',
          TERMS_CONTENT7_6: '- 5. 기타 “서비스”의 정상적 운영 유지 등을 방해하는 행위',
          TERMS_CONTENT7_7:
            '2. “회원”은 이 약관에서 규정하는 사항, 운영정책, 관계법령을 준수해야 하며, 기타 “회사”의 명예를 손상시키거나 업무수행에 현저한 지장을 초래하는 행위를 해서는 안됩니다.',
          TERMS_TITLE8: '제 8 조 재판권 및 준거법',
          TERMS_CONTENT8_1: '1. 이 약관에 명시되지 않은 사항은 대한민국 관계 법령에 따릅니다.',
          TERMS_CONTENT8_2: '2. 서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 민사소송법상의 주소지를 관할하는 법원을 합의관할로 합니다.',
        },
        // Privacy policy
        POLICY: {
          TITLE: '개인정보 방침',
          POLICY_TITLE1: '1. 수집하는 개인정보의 항목 및 수집방법',
          POLICY_CONTENT1_1: '가. 수집하는 개인정보의 항목',
          POLICY_CONTENT1_2: '서비스 회원가입 과정에서 아래와 같은 개인정보를 수집합니다.',
          POLICY_CONTENT1_3: '- 공통 정보: (필수) 이메일 주소, ID',
          POLICY_CONTENT1_4: '서비스 이용과정에서 아래와 같은 정보가 생성되어 수집될 수 있습니다.',
          POLICY_CONTENT1_5: '- IP Address, 쿠키, 방문 일시, 서비스 이용 기록',
          POLICY_TITLE2: '2. 개인정보의 수집 및 이용목적',
          POLICY_CONTENT2_1: '회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.',
          POLICY_CONTENT2_2: '- 이용자와 약속한 서비스 제공, 이용자 본인 확인 및 식별, 회원탈퇴 의사의 확인, 문의사항 또는 불만처리 등',
          POLICY_TITLE3: '3. 개인정보의 보유 및 이용기간',
          POLICY_CONTENT3_1: '회사는 원칙적으로 이용자의 개인정보를 회원탈퇴 시까지 보유합니다.',
        },
      },
    },
  },
  function () {
    $('body').i18n();
  },
);

var changeLang = function (lang) {
  $.i18n.setLng(lang);
  $('body').i18n();
};
